module.exports = __webpack_public_path__ + "static/media/icon_youtube.778b4e67.svg";